import axiosInstance from "../axiosInstance";
export const listSettings=(path,params={})=>axiosInstance.get(`settings/${path}/`,{params}).then(r=>r.data.results||r.data);
export const getSetting=(path,id)=>axiosInstance.get(`settings/${path}/${id}/`).then(r=>r.data);
export const createSetting=(path,data)=>axiosInstance.post(`settings/${path}/`,data).then(r=>r.data);
export const updateSetting=(path,id,data)=>axiosInstance.patch(`settings/${path}/${id}/`,data).then(r=>r.data);
export const deleteSetting=(path,id)=>axiosInstance.delete(`settings/${path}/${id}/`);
export const getCompany=()=>axiosInstance.get("settings/company/").then(r=>r.data);
export const updateCompany=(data)=>axiosInstance.patch("settings/company/",data,{headers:{"Content-Type":"multipart/form-data"}}).then(r=>r.data);
